const DEFAULT_PUBLIC_ORIGIN = 'https://prevencor.moraes-tech.com';

export function getValidacaoBaseUrl() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    const host = window.location.hostname;
    if (host && host !== 'localhost' && host !== '127.0.0.1') {
      return window.location.origin.replace(/\/$/, '');
    }
  }

  return DEFAULT_PUBLIC_ORIGIN;
}

/**
 * Monta a URL pública de validação para o QR Code dos PDFs,
 * seguindo o padrão URLSearchParams (`paramsValidacao`).
 *
 * Ex.: https://prevencor.moraes-tech.com/receita/validacao?receita=123&paciente=456
 */
export function buildValidacaoQrCodeUrl({ tipo, codDocumento, codPaciente }) {
  const normalizedTipo = String(tipo || 'receita')
    .trim()
    .toLowerCase();
  const paramsValidacao = new URLSearchParams({
    [normalizedTipo]: String(codDocumento ?? ''),
    paciente: String(codPaciente ?? ''),
  });

  return `${getValidacaoBaseUrl()}/${normalizedTipo}/validacao?${paramsValidacao.toString()}`;
}
